export * from './IconWatchStroked';
